/** Norwegian Bokmål IPA overrides for words not in the dictionary. */
export const nb: Record<string, string> = {
  // Old orthography (Riksmål/Danish) and common words
  al: 'ɑːl',
  årsalderen: 'oːɾsɑlːdəɾən',
  arv: 'ɑɾv',
  behold: 'bəhɔl',
  Bjørgulfson: 'bjøːɾɡʉlfsɔn',
  Blik: 'blɪk',
  Bliv: 'bliː',
  bør: 'bøːɾ',
  Børnene: 'bøːɳənə',
  brorskapets: 'bɾuːɾskɑːpəts',
  demokratiet: 'dɛmokɾɑtiːə',
  dig: 'dɑj',
  Dyb: 'dyːp',
  Eftermiddag: 'ɛftɛɾmɪdɑːɡ',
  ej: 'ɑj',
  fandens: 'fɑnːəns',
  fått: 'fɔt',
  fiender: 'fiːɛndəɾ',
  Fjeldbygden: 'fjɛlbʏɡdən',
  fordrukken: 'fɔɾdɾʉkːən',
  fornuft: 'fɔɾnʉft',
  frem: 'fɾɛm',
  Fremmedkarl: 'fɾɛmːəkɑɾl',
  frostblaa: 'fɾɔstbloː',
  frygt: 'fɾʏkt',
  gamlingen: 'ɡɑmlɪŋən',
  Gem: 'jɛm',
  gikk: 'jɪk',
  Gjesling: 'jɛslɪŋ',
  gjorde: 'juːɾə',
  Glands: 'ɡlɑns',
  gnistred: 'ɡnɪstɾəd',
  gråsprængt: 'ɡɾoːspɾɛŋt',
  Grunnlov: 'ɡɾʉnːloːv',
  Guld: 'ɡʉl',
  Gyldenlak: 'jʏlːənlɑk',
  Gyldentop: 'jʏlːəntɔp',
  ham: 'hɑm',
  Hej: 'hɑj',
  hør: 'høːɾ',
  Horisonten: 'hɔɾɪsɔntən',
  humanistiske: 'hʉmɑnɪstɪskə',
  husbond: 'hʉːsbɔn',
  Hvad: 'vɑ',
  hvem: 'vɛm',
  hverandre: 'vɛɾɑndɾə',
  hverken: 'vɛɾkən',
  Hvor: 'vuːɾ',
  hvoraf: 'vuːɾɑv',
  Hvorfor: 'vɔɾfɔɾ',
  Hvormeget: 'vuːɾmɑjːə',
  iaften: 'iɑftən',
  Idet: 'iːdeːt',
  ihob: 'ihoːb',
  imellem: 'imɛlːəm',
  imod: 'iːmuːt',
  inn: 'ɪn',
  intet: 'ɪntə',
  Intet: 'ɪntə',
  Ivar: 'iːvɑɾ',
  Jammer: 'jɑmɛɾ',
  Jensen: 'jɛnsən',
  jordegods: 'juːɾəɡɔts',
  juletræet: 'jʉːlətɾɛːə',
  just: 'jʉst',
  kan: 'kɑn',
  kanske: 'kɑnʃə',
  Kjøttmeisene: 'çøtmæɪsənə',
  kold: 'kɔl',
  kom: 'kɔm',
  Kongeriket: 'kɔŋəɾiːkə',
  Kringsatt: 'kɾɪŋsɑt',
  Kristiania: 'kɾɪstɪɑːnɪɑ',
  kristne: 'kɾɪstnə',
  Landets: 'lɑnəts',
  Lavrans: 'lɑːvɾɑns',
  lektor: 'lɛktɔɾ',
  lig: 'liːɡ',
  må: 'moː',
  maa: 'moː',
  Mandemagt: 'mɑnːəmɑkt',
  menneskerettighetene: 'mɛnːəskəɾɛtːɪɡheːtənə',
  menneskerettigheter: 'mɛnːəskəɾɛtːɪɡheːtəɾ',
  menneskeverd: 'mɛnːəskəveːɾd',
  mig: 'mɑj',
  mod: 'moːd',
  monarkisk: 'mɔnɑɾkɪsk',
  Muld: 'mʉl',
  Nej: 'nɑj',
  noget: 'noːə',
  nøgne: 'nøjnə',
  Norge: 'nɔɾɡə',
  nu: 'nʉː',
  nysnøen: 'nyːsnøːən',
  øjne: 'ɔjnə',
  op: 'ɔp',
  Peer: 'peːɾ',
  Plads: 'plɑs',
  proppenerer: 'pɾɔpəneːɾəɾ',
  Puslinger: 'pʉːslɪŋəɾ',
  raaber: 'ɾoːbəɾ',
  Række: 'ɾɛkə',
  rækker: 'ɾɛkːəɾ',
  Ragnfrid: 'ɾɑŋnfɾiːd',
  regjeringsform: 'ɾejeːɾɪŋsfɔɾm',
  rettsstaten: 'ɾɛtːsːtɑːtən',
  Rosentinter: 'ɾuːsəntɪntɛɾ',
  rummeligt: 'ɾʉmːəlɪɡt',
  Ryg: 'ɾʏɡ',
  saganatt: 'sɑːɡɑnɑt',
  samvittighet: 'sɑmvɪtːɪɡheːt',
  sidste: 'sɪstə',
  siger: 'siːəɾ',
  skabt: 'skɑpt',
  skal: 'skɑl',
  Skar: 'skɑːɾ',
  skjæms: 'ʃɛms',
  Skodden: 'skɔdːən',
  Skydsskiftet: 'ʃʏtsskɪftə',
  slig: 'sliːɡ',
  smaa: 'smoː',
  Snees: 'sneːs',
  Sneskavler: 'sneːskɑːvlɛɾ',
  Sørby: 'søːɾbyː',
  spør: 'spøːɾ',
  steget: 'steːɡə',
  stundom: 'stʉndɔm',
  stygt: 'stʏkt',
  Sundbu: 'sʉnbʉː',
  Syd: 'syːd',
  tabt: 'tɑpt',
  Tant: 'tɑnt',
  Terje: 'tɛɾjə',
  Tøv: 'tøːv',
  Tvi: 'tviː',
  tykkner: 'tʏkːnəɾ',
  uavhendelig: 'ʉːɑvhɛndəlɪɡ',
  udekket: 'ʉːdɛkːə',
  udelelig: 'ʉːdeːləɡ',
  uden: 'ʉːdən',
  underjordisk: 'ʉnːəɾjuːɾdɪsk',
  værbitt: 'væːɾbɪt',
  vejr: 'veːɾ',
  Verdigrunnlaget: 'veːɾdɪɡɾʉnːlɑːɡə',
  Vigen: 'viːɡən',
  vil: 'vɪl',
  Vindvet: 'vɪndvə',
  visst: 'vɪst',
  Vorherres: 'voːɾhɛɾəs',
  yderste: 'yːdəɾstə',
};
